import { useEffect, useState } from 'react'
import Grid from 'antd/es/grid/index'
import type { Breakpoint } from 'antd/es/_util/responsiveObserver.d.ts'

const { useBreakpoint } = Grid

export const useIsMobile = (breakpoint: number = 768): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint])

  return isMobile
}

export function useFixedBreakpoint(): Partial<Record<Breakpoint, boolean>> {
  const screens = useBreakpoint()
  const xxl = screens.xxl ?? window.innerWidth >= 1600
  const xl = screens.xl ?? window.innerWidth >= 1200
  const lg = screens.lg ?? window.innerWidth >= 992
  const md = screens.md ?? window.innerWidth >= 768
  const sm = screens.sm ?? window.innerWidth >= 576
  const xs = screens.xs ?? window.innerWidth < 480
  return { xxl, xl, lg, md, sm, xs }
}
